import { AiChatContext as e } from "../context/AiChatContext.mjs";
import { useContext as t } from "react";
//#region src/hooks/useAiChat.ts
var n = () => {
	let n = t(e);
	if (!n) throw Error("useAiChat must be used inside <AiChatProvider>");
	return n;
};
//#endregion
export { n as useAiChat };
